import React from 'react';
import { Toaster } from 'sonner';
import { Nav } from './components/Nav';
import { Marquee } from './components/Marquee';
import { Hero } from './components/Hero';
import { Drops } from './components/Drops';
import { About } from './components/About';
import { Lookbook } from './components/Lookbook';
import { Community } from './components/Community';
import { Newsletter } from './components/Newsletter';
import { Footer } from './components/Footer';
export function App() {
  return <div dir="rtl" className="min-h-screen bg-white text-black font-sans selection:bg-acid selection:text-black" data-id="element-0">
      <Toaster position="top-center" toastOptions={{
      className: 'brutal-border brutal-shadow bg-acid text-black font-black text-xl rounded-none border-4 border-black',
      style: {
        borderRadius: 0
      }
    }} data-id="element-1" />
      <Nav data-id="element-2" />
      <Marquee data-id="element-3" />
      <main data-id="element-4">
        <Hero data-id="element-5" />
        <Drops data-id="element-6" />
        <About data-id="element-7" />
        <Lookbook data-id="element-8" />
        <Community data-id="element-9" />
        <Newsletter data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}